export const spaceName = 'odEvent';

export interface EventSettings {
  editingId: number;
  originalData: {
    originBasicInfo: any;
    originSelectedId: any[];
  };

  currentData: {
    currentSelectedId: any;
    currentBasicInfo: any[];
  };
  relationData: any;
}

export default {} as EventSettings;
